import { useEffect } from 'react';
import { __DEV__ } from 'app/constants/AppConstants';
import { getAppCountryCode } from 'app/selectors/AppSelectors';
import { getAnalyticsRequest, appendYaSharedMetrics, appendYaKinokassa } from 'app/modules/analytics/analyticsHelpers';
import { usePrevious } from 'app/hooks';
import { shallowEqual, useSelector } from 'react-redux';
import { getCurrentCityId, getIsKinokassa, getCurrentCinemas } from 'app/selectors/AppSelectors';
import { IReduxState } from 'app/types/state';
import { getIsAnalyticsAllowed, getUserCookieSettings } from 'app/modules/analytics/redux/analyticsSelectors';
import { KINOKASSA_METRICS_ID, SHARED_METRICS_ID } from 'app/constants/SettingsConstants';

export const useAnalytics = () => {
	const userCookieSettings = useSelector(getUserCookieSettings);

	const {
		cityId, currentCinemas, isKinokassa, appCountryCode, isAnalyticsAllowed
	} = useSelector((state: IReduxState) => ({
		cityId: getCurrentCityId(state),
		currentCinemas: getCurrentCinemas(state),
		isKinokassa: getIsKinokassa(state),
		appCountryCode: getAppCountryCode(state),
		isAnalyticsAllowed: getIsAnalyticsAllowed(state),
	}), shallowEqual)

	const prevCurrentCinemas = usePrevious(currentCinemas);
	const prevCityId = usePrevious({cityId});
	const prevIsAnalyticsAllowed = usePrevious(isAnalyticsAllowed);

	useEffect(() => {
		document.body.setAttribute("data-is-analytics-cookie-allowed", `${userCookieSettings.isAnalyticsCookieAllowed}`);
		document.body.setAttribute("data-is-marketing-cookie-allowed", `${userCookieSettings.isMarketingCookieAllowed}`);
	}, [userCookieSettings]);

	useEffect(() => {
		if (!__DEV__ && isAnalyticsAllowed) {
			if (!isKinokassa && !window[`yaCounter${SHARED_METRICS_ID}`]) {
				appendYaSharedMetrics();
			} else if (isKinokassa && !window[`yaCounter${KINOKASSA_METRICS_ID}`]) {
				appendYaKinokassa();
			}
		}
	}, [isAnalyticsAllowed])

	useEffect(() => {
		if (!__DEV__ && isAnalyticsAllowed && !isKinokassa && appCountryCode &&
			(
				!prevCurrentCinemas?.length && currentCinemas.length || prevCityId?.cityId && cityId !== prevCityId?.cityId ||
				prevIsAnalyticsAllowed !== isAnalyticsAllowed
			)
		) {
			const currentCinemasIds = currentCinemas.map((cinemaObj) => cinemaObj.id);

			getAnalyticsRequest(currentCinemasIds, appCountryCode);
		}
	}, [isKinokassa, currentCinemas, cityId, appCountryCode, isAnalyticsAllowed]);
}